<template>
  <div>
    <div class="b-b p-l-20" style="height: 50px;line-height: 50px">
      <span class="fs-18 bold color-33">{{iteminfo.typename}}{{iteminfo.name}}</span>
    </div>
    <div class="p-20 o-y-auto noscroll" ref="scrollDiv" style="height: calc(100% - 50px)">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSettingWidget',
  props: {
    iteminfo: {
      style: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
